(function () {
    function destroyGallery() {
        $(".gallery--carousel a").unwrap();
        $(".gallery--carousel").trigger("destroy.owl.carousel");
    }

    function addDotButtonText() {
        // loop through each dot element
        $(".owl-dot").each(function () {
            // grab its (zero-based) order in the series
            let idx = $(this).index() + 1;

            // append a span to the button containing descriptive text
            $(this)
                .find("span")
                .append(
                    '<span class="screen-reader-text">Go to slide ' +
                        idx +
                        "</span>"
                );
        });
    }

    function initMobileGallery() {
        if ($(".photo__group").length) {
            destroyGallery();
        }

        // group items
        $(".gallery--carousel").each(function () {
            var items = $(this).find("a");

            for (var i = 0; i < items.length; i += 1) {
                items.slice(i, i + 1).wrapAll('<div class="photo__group">');
            }
        });

        // init carousel
        $(".gallery--carousel").owlCarousel({
            loop: false,
            items: 1,
            navElement: "div",
            lazyLoad: true,
            dots: true,
            nav: false,
            mouseDrag: true,
            touchDrag: true,
            onInitialized: addDotButtonText,
            onResized: addDotButtonText,
        });
    }

    function initTabletGallery() {
        if ($(".photo__group").length) {
            destroyGallery();
        }

        // group items
        $(".gallery--carousel").each(function () {
            var items = $(this).find("a");

            for (var i = 0; i < items.length; i += 4) {
                items.slice(i, i + 4).wrapAll('<div class="photo__group">');
            }
        });

        // init carousel
        $(".gallery--carousel")
            .owlCarousel({
                loop: false,
                items: 1,
                lazyLoad: true,
                dots: true,
                nav: false,
                mouseDrag: true,
                navElement: "div",
                touchDrag: true,
                onInitialized: addDotButtonText,
                onResized: addDotButtonText,
            })
            .trigger("refresh.owl.carousel");
    }

    // Add accessibility to nav
    function patchOwlNavAria($carousel) {
        const $prev = $carousel.find(".owl-prev");
        const $next = $carousel.find(".owl-next");
        
        $prev.attr({
            type: "button",
            "aria-label": "Previous slide",
            title: "Previous slide",
        });
        
        $next.attr({
            type: "button",
            "aria-label": "Next slide",
            title: "Next slide",
        });
        
        // Reflect disabled state accessibly
        [$prev, $next].forEach(function ($btn) {
            const disabled = $btn.hasClass("disabled");
            $btn.attr("aria-disabled", disabled ? "true" : "false");
            $btn.prop("disabled", disabled);
            if (disabled) {
            $btn.attr("tabindex", "-1");
            } else {
            $btn.removeAttr("tabindex");
            }
        });
    }

    function initDesktopGallery() {
        if ($(".photo__group").length) {
            destroyGallery();
        }

        // group items
        $(".gallery--carousel").each(function () {
            var items = $(this).find("a");

            for (var i = 0; i < items.length; i += 8) {
                items.slice(i, i + 8).wrapAll('<div class="photo__group">');
            }
        });
        // init carousel
        $(".gallery--carousel")
        .owlCarousel({
          loop: false,
          items: 1,
          lazyLoad: true,
          dots: false,
          nav: true,
          navElement: "button",
          navText: ["keyboard_arrow_left", "keyboard_arrow_right"],
          mouseDrag: false,
          touchDrag: false,
      
          onInitialized: function (event) {
            patchOwlNavAria($(event.target));
          },
          onResized: function (event) {
            patchOwlNavAria($(event.target));
          },
          onRefreshed: function (event) {
            patchOwlNavAria($(event.target));
          },
          onChanged: function (event) {
            patchOwlNavAria($(event.target));
          },
        })
        .trigger("refresh.owl.carousel");
    }

    $(window).on("load", function () {
        var gallery = $(".gallery");

        gallery.each(function () {
            // Setup gallery as a carousel
            if ($(this).is(".gallery--carousel")) {
                enquire.register("screen and (max-width:767px)", {
                    match: function () {
                        initMobileGallery();
                    },
                });

                enquire.register(
                    "screen and (min-width:768px) and (max-width:959px)",
                    {
                        match: function () {
                            initTabletGallery();
                        },
                    }
                );

                enquire.register("screen and (min-width:960px)", {
                    match: function () {
                        initDesktopGallery();
                    },
                });
            }

            // Setup gallery as masonry grid
            else {
                var Shuffle = window.shuffle;
                var element = $(this);

                var shuffle = new Shuffle(element, {
                    itemSelector: ".gallery a",
                    sizer: ".gallery .photo",
                });
            }
        });
    });
})(this);
